<app-pan-card
  [isPageContainer]="true"
  [pageContainerSize]="'xl'"
  [header]="'Review Management'"
  [subheader]="'Last Updated: ' + (startOfWeek() | date: 'medium')"
>
  <div rightActions>
    <app-pan-button-group [(panRadioGroup)]="pageReviewsOrIncidents">
      <app-pan-button [panRadio]="'reviews'" color="primary"> Total Reviews</app-pan-button>
      <app-pan-button [panRadio]="'incidents'" color="primary"> Incidents </app-pan-button>
    </app-pan-button-group>
  </div>

  <app-page-filters
    [allowBranchSelection]="true"
    branchSelectionLabel="Select Branches"
    [branchSelectionMulti]="true"
    [branchSelectionSelectDefault]="true"
    [(selectedBranches)]="selectedBranches"
    [branchSelectionAutoSelectBranchIds]="pageBranchIds()"
    (selectedBranchesChange)="updatePageBranchIds()"
    [allowLocationGroupSelection]="true"
    [locationGroupSelectionLabel]="'Select Location Group'"
    [locationGroupSelectionMulti]="false"
    [locationGroupSelectionShowExternalId]="true"
    [locationGroupSelectionAutoSelectLocationIds]="pageLocationGroupIds()"
    [(selectedLocationGroups)]="selectedLocationGroup"
    (selectedLocationGroupsChange)="updatePageLocationGroupIds()"
  >
  </app-page-filters>
</app-pan-card>

@if (usage.isLoading()) {
  <app-pan-blank-slate> <app-pan-spinner></app-pan-spinner> Loading... </app-pan-blank-slate>
} @else {
  @for (branch of usage.value().items; track branch.id) {
    @defer (on viewport) {
      <app-review-management-branch-card
        [branch]="branch"
        [intervals]="usage.value().intervals"
        [isLoading]="reloadingBranchIds().includes(branch.id)"
        [displayType]="pageReviewsOrIncidents()"
        (reloadRequested)="reloadBranch(branch.id)"
      ></app-review-management-branch-card>
    } @placeholder {
      <div class="branch-card-placeholder">
        <app-pan-card [isPageContainer]="true" [pageContainerSize]="'xl'" [header]="branch.name">
          <app-pan-blank-slate> <app-pan-spinner></app-pan-spinner> Loading... </app-pan-blank-slate>
        </app-pan-card>
      </div>
    }
  } @empty {
    @if (hasFilters()) {
      <app-pan-blank-slate> No locations found for the selected filters </app-pan-blank-slate>
    }
  }
}
